import React, { useState, useEffect } from "react";
import { FiChevronDown, FiChevronUp, FiRefreshCw } from "react-icons/fi";
import { GiBoneKnife } from "react-icons/gi";
import { FiHeadphones, FiCpu, FiVolume2 } from "react-icons/fi";
import { MdHearing } from "react-icons/md";
import { RiUserVoiceLine } from "react-icons/ri";
import styles from "./CalibrationDrawer.module.scss";
import SoundCard from "../soundCard/SoundCard";
import SpeakersSettings from "../speakers/SpeakersSettings";
import BoneCalib from "../calibrationData/BoneCalib";
import HeadphoneCalib from "../calibrationData/HeadphoneCalib";
import InsertsCalib from "../calibrationData/InsertsCalib";
import OperatorCalib from "../calibrationData/OperatorCalib";

const SECTIONS = [
  { key: "sound", label: "Cartes sons", Icon: FiCpu },
  { key: "speakers", label: "Configuration CL", Icon: FiVolume2 },
  { key: "bone", label: "Configuration CO", Icon: GiBoneKnife },
  { key: "headphone", label: "Configuration Casque", Icon: FiHeadphones },
  { key: "inserts", label: "Configuration Inserts", Icon: MdHearing },
  { key: "operator", label: "Configuration Operator", Icon: RiUserVoiceLine },
];

export default function CalibrationDrawer({
  cabId,
  setCabId,
  cabname,
  cabine,
  initialSection,
  onCalibrationSaved,
}) {
  const [openSections, setOpenSections] = useState(() => {
    const init = {};
    SECTIONS.forEach(({ key }) => {
      init[key] = key === initialSection;
    });
    return init;
  });

  useEffect(() => {
    const next = {};
    SECTIONS.forEach(({ key }) => {
      next[key] = key === initialSection;
    });
    setOpenSections(next);
  }, [initialSection]);

  const toggle = (key) =>
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className={styles.drawerWrap}>
      {onCalibrationSaved && (
        <button
          type="button"
          className={styles.refreshBtn}
          onClick={onCalibrationSaved}
        >
          <FiRefreshCw /> Rafraîchir les calibrations
        </button>
      )}
      {SECTIONS.map(({ key, label, Icon }) => (
        <div className={styles.drawerSection} key={key}>
          <button
            type="button"
            className={styles.collapsibleHeader}
            onClick={() => toggle(key)}
          >
            <span className={styles.drawerSectionTitle}>
              <Icon className={styles.sectionIcon} />
              {label}
            </span>
            {openSections[key] ? <FiChevronUp /> : <FiChevronDown />}
          </button>
          {openSections[key] && (
            <div className={styles.collapsibleContent}>
              {key === "sound" && (
                <SoundCard key={cabId} cabId={cabId} setCabId={setCabId} cabname={cabname} />
              )}
              {key === "speakers" && (
                <SpeakersSettings
                  key={cabId}
                  cabId={cabId}
                  setCabId={setCabId}
                  cabname={cabname}
                  cabine={cabine}
                  onCalibrationSaved={onCalibrationSaved}
                />
              )}
              {key === "bone" && (
                <BoneCalib key={cabId} cabId={cabId} setCabId={setCabId} cabname={cabname} onCalibrationSaved={onCalibrationSaved} />
              )}
              {key === "headphone" && (
                <HeadphoneCalib key={cabId} cabId={cabId} setCabId={setCabId} cabname={cabname} onCalibrationSaved={onCalibrationSaved} />
              )}
              {key === "inserts" && (
                <InsertsCalib key={cabId} cabId={cabId} setCabId={setCabId} cabname={cabname} onCalibrationSaved={onCalibrationSaved} />
              )}
              {key === "operator" && (
                <OperatorCalib key={cabId} cabId={cabId} setCabId={setCabId} cabname={cabname} onCalibrationSaved={onCalibrationSaved} />
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
